export interface SportsbookBlockState {
	isSportsbookBlocked?: boolean;
	isPlayerProfileSelected?: boolean;
	isSelectionPostponed?: boolean;
}

export interface SportsbookBlockUpdate {
	isSportsbookBlocked: boolean;
	isPlayerProfileSelected: boolean;
}

export const SPORTSBOOK_CLASSIFICATIONS = ["Sportsbook"];
